import React, { FC, ReactNode } from "react";
import classNames from "classnames";

import "./style.scss";

export interface ChipProps {
  children: ReactNode;
  appearance?: "default" | "success";
}

export const Chip: FC<ChipProps> = ({ appearance, children }) => {
  return <div className={classNames("chip", appearance)}>{children}</div>;
};
